import {useUserSession, useUserUpdate} from "../../utils/UserSession";
import {useCallback, useMemo, useState} from "react";
import {ObjectUtil} from "zavadil-ts-common";
import LoginPage from "../public/LoginPage";
import {Route, Routes} from "react-router";
import NotFoundPage from "../public/NotFoundPage";
import {useRestClient} from "../../client/SpmRestClient";
import ProfilePage from "./users/ProfilePage";
import UsersList from "./users/UsersList";
import UserPage from "./users/UserPage";
import ContactsPage from "./contacts/ContactsPage";
import NodesPage from "./nodes/NodesPage";
import ScraperPage from "./scraper/ScraperPage";
import ContactsImportPage from "./import/ContactsImportPage";
import CheckPage from "./check/CheckPage";

export default function AdminSection() {
	const restClient = useRestClient();
	const session = useUserSession();
	const isLoggedIn = useMemo(() => ObjectUtil.notEmpty(session.user), [session]);
	const updateUser = useUserUpdate();
	const [lastLogin, setLastLogin] = useState<string>('');
	const [inProgress, setInProgress] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	const logIn = useCallback(
		(login: string, password: string) => {
			setInProgress(true);
			setErrorMessage(null);
			setLastLogin(login);
			restClient.logIn(login, password)
				.then((at) => {
					restClient.users.profile()
						.then(updateUser)
						.catch((e) => {
							let message = 'Načtení uživatele selhalo';
							if (e instanceof Error) {
								message += `: ${e.message}`;
							} else if (typeof e === 'string') {
								message += `: ${e}`;
							}
							setErrorMessage(message);
						})
				})
				.catch((e) => {
					let message = 'Přihlášení selhalo';
					if (e instanceof Error) {
						message += `: ${e.message}`;
					} else if (typeof e === 'string') {
						message += `: ${e}`;
					}
					setErrorMessage(message);
				})
				.finally(() => setInProgress(false));
		},
		[restClient, updateUser]
	);

	if (!isLoggedIn) {
		return <LoginPage onConfirmed={logIn} lastLogin={lastLogin} errorMessage={errorMessage} inProgress={inProgress}/>
	}

	return (
		<div className="p-3">
			<Routes>
				<Route path="profile" element={<ProfilePage/>}/>
				<Route path="users" element={<UsersList/>}/>
				<Route path="user" element={<UserPage/>}/>
				<Route path="user/:id" element={<UserPage/>}/>
				<Route path="contacts" element={<ContactsPage/>}/>
				<Route path="nodes" element={<NodesPage/>}/>
				<Route path="scraper" element={<ScraperPage/>}/>
				<Route path="check" element={<CheckPage/>}/>
				<Route path="contacts-import/sluzby-pro-migranty" element={<ContactsImportPage/>}/>
				<Route path="*" element={<NotFoundPage/>}/>
			</Routes>
		</div>
	);
}
